var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-container",style:(_vm.containerStyle)},[_c('div',{staticClass:"public-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }